import React, { FC } from 'react';
import { RouteComponentProps } from 'react-router';
import { map } from 'lodash';
import { IsoDocument } from '@bechtel/types';
import {
  Text,
  Heading,
  Icon,
  Box,
  Button,
  ButtonAppearance,
  SideSheet,
  SideSheetHeader,
  SideSheetSubHeader,
  SideSheetBody,
  SideSheetClose,
  SideSheetContentCol,
  SideSheetFooter,
} from '@bechtel/gds';
import { useDate } from '@bechtel/client-common';
import { useWorkPackage } from '../context';
import { WpDocumentLinkStyled } from './styled';
import { t, Trans } from '@lingui/macro';

type DocumentsProps = RouteComponentProps & {
  documents: IsoDocument[];
};

const Documents: FC<DocumentsProps> = ({ history, documents }) => {
  const goBack = () => history.goBack();
  const { formatISODate } = useDate();
  const { tag: workPackageTag, startDate: workPackageStartDate, endDate: workPackageEndDate } = useWorkPackage();
  const startDateFormatted = workPackageStartDate ? formatISODate(workPackageStartDate) : 'N/A';
  const endDateFormatted = workPackageEndDate ? formatISODate(workPackageEndDate) : 'N/A';

  return (
    <SideSheet visible onDismiss={goBack}>
      <SideSheetHeader title={t`Documents`}>
        <SideSheetClose onClick={goBack}></SideSheetClose>
      </SideSheetHeader>
      <SideSheetSubHeader>
        <Box>
          <Heading>
            <Trans>WorkPackage</Trans>:
          </Heading>
          &nbsp;<Text>{workPackageTag}</Text>
        </Box>
        <Box pt={{ sm: '400' }}>
          <Text size={'300'} color={'grey.600'}>
            {startDateFormatted} - {endDateFormatted}
          </Text>
        </Box>
      </SideSheetSubHeader>
      <SideSheetBody>
        <SideSheetContentCol>
          <Box flexDirection={{ sm: 'column' }}>
            {documents.length === 0 && (
              <Box p={{ sm: '500' }}>
                <Trans>There are no ISO documents for this work package.</Trans>
              </Box>
            )}

            {map(documents, (document) => {
              return (
                <WpDocumentLinkStyled href={document.url} target="_blank">
                  <Box justifyContent={{ sm: 'space-between' }}>
                    <Text>{document.documentNumber}</Text>
                    <Icon icon="chevron-right" />
                  </Box>
                </WpDocumentLinkStyled>
              );
            })}
          </Box>
        </SideSheetContentCol>
      </SideSheetBody>
      <SideSheetFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={goBack}>
              <Trans> Close</Trans>
            </Button>
          </Box>
        </Box>
      </SideSheetFooter>
    </SideSheet>
  );
};

export default Documents;
